<template>
  <div id="app-content">
    <app-header/>
    <main id="main-content">
      <router-view/>
    </main>
    <app-mobile-tabs/>
    <setting-modal></setting-modal>
    <view-tag-info></view-tag-info>
    <app-directory-modal :edit="true"></app-directory-modal>
    <e-invoice-account-list-modal></e-invoice-account-list-modal>
    <rule-list-modal/>
    <report-statistics-modal></report-statistics-modal>
    <invoice-upload-modal></invoice-upload-modal>
    <invoice-import-modal></invoice-import-modal>
    <invoice-import-result-modal></invoice-import-result-modal>
    <invoice-import-error-modal></invoice-import-error-modal>
    <invoice-approve-list-modal></invoice-approve-list-modal>
    <move-directory-modal/>
    <invoice-paid-modal/>
    <create-rule-modal/>
    <create-directory-modal/>
    <invoice-form-modal></invoice-form-modal>
    <create-virtual-invoice-form-modal></create-virtual-invoice-form-modal>
    <detailed-notification-modal></detailed-notification-modal>
    <import-invoice-modal></import-invoice-modal>
    <create-invoice-form-modal></create-invoice-form-modal>
    <error-reported-modal></error-reported-modal>
    <user-profile-modal></user-profile-modal>
    <user-list-modal></user-list-modal>
    <company-profile-modal></company-profile-modal>
    <company-license-modal></company-license-modal>
    <app-autocomplete-search-result></app-autocomplete-search-result>
    <e-invoice-account-modal></e-invoice-account-modal>
    <clone-invoice-result-modal></clone-invoice-result-modal>
    <company-list-modal></company-list-modal>
    <tax-account-connect-modal></tax-account-connect-modal>
    <adv-modal></adv-modal>
    <publish-invoice-info-modal></publish-invoice-info-modal>
    <benefits-modal></benefits-modal>
    <get-template-modal></get-template-modal>
    <invoice-viewer-modal></invoice-viewer-modal>
    <invoice-tag-modal></invoice-tag-modal>
    <invoice-review-modal></invoice-review-modal>
    <manage-tag-modal></manage-tag-modal>
    <tag-modal></tag-modal>
    <external-invoice-modal></external-invoice-modal>
    <actions-invoice-modal></actions-invoice-modal>
    <invoice-preview-modal></invoice-preview-modal>
    <send-email-modal></send-email-modal>
    <choose-tax-period-modal/>
    <vat-return-modal/>
    <usb-token-error-modal></usb-token-error-modal>
    <save-invoice-draft-modal></save-invoice-draft-modal>
    <!-- Dialog luôn để ở cuối -->
    <app-dialog></app-dialog>

    <transition name="slow-hide">
      <div v-if="appLoading" class="overlay animated-element">
        <div class="row">
          <div class="col-12 text-center">
            <i class="fad fa-spinner-third fa-spin fa-lg"></i>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppHeader from '@/layouts/app-header';
import AppFooter from '@/layouts/app-footer';
import AppMobileTabs from '@/components/app-mobile-tabs';

import AppDirectoryModal from '@/portal-components/directory-list/app-directory-modal';
import RuleListModal from '@/portal-components/rule/rule-list';
import CreateRuleModal from '@/portal-components/rule/create-rule-modal';
import MoveDirectoryModal from '@/portal-components/directory-list/move-directory-modal';
import InvoicePaidModal from '@/portal-components/invoice/invoice-paid-modal';
import InvoiceList from '@/portal-components/invoice/invoice-list';
import InvoiceViewerModal from '@/portal-components/invoice/invoice-viewer-modal';
import InvoiceUploadModal from '@/portal-components/invoice/invoice-upload-modal';
import InvoiceImportModal from '@/portal-components/invoice/invoice-import-modal';
import InvoiceImportResultModal from '@/portal-components/invoice/invoice-import-result-modal';
import InvoiceImportErrorModal from '@/portal-components/invoice/invoice-import-error-modal';
import InvoiceApproveListModal from '@/portal-components/invoice/invoice-approve-list-modal';
import ReportStatisticsModal from '@/portal-components/report/report-statistics-modal';
import InvoiceFormModal from '@/portal-components/invoice/invoice-form-modal';
import CreateInvoiceFormModal from '@/portal-components/invoice/create-invoice-form-modal';
import GetTemplateModal from '@/portal-components/invoice/get-template-modal';
import CreateVirtualInvoiceFormModal from '@/portal-components/invoice/create-virtual-invoice-form-modal';
import CreateDirectoryModal from '@/portal-components/directory-list/create-directory-modal';
import AppDialog from '@/components/app-modal/confirm-dialog';
import UserProfileModal from '@/portal-components/user/user-profile-modal';
import UserListModal from '@/portal-components/user/user-list-modal';
import CompanyProfileModal from '@/portal-components/user/company-profile-modal';
import CompanyLicenseModal from '@/portal-components/user/company-license-modal';
import EInvoiceAccountListModal from '@/portal-components/invoice/e-invoice-account-list-modal';
import TagModal from '@/portal-components/tag/tag-modal';
import ViewTagInfo from '@/portal-components/tag/view-tag-info';
import InvoiceTagModal from '@/portal-components/invoice/invoice-tag-modal';
import ManageTagModal from '@/portal-components/invoice/manage-tag-modal';
import InvoiceReviewModal from '@/portal-components/invoice/invoice-review-modal';
import AppAutocompleteSearchResult from '@/components/app-autocomplete/search-result';
import EInvoiceAccountModal from '@/portal-components/invoice/e-invoice-account-modal';
import CloneInvoiceResultModal from '@/portal-components/invoice/clone-invoice-result-modal';
import CompanyListModal from '@/portal-components/customer/company-list-modal';
import TaxAccountConnectModal from '@/portal-components/user/tax-account-connect-modal';
import SettingModal from '@/portal-components/setting/setting-modal';
import ImportInvoiceModal from '@/portal-components/invoice/import-invoice-form-modal';
import UsbTokenErrorModal from '@/portal-components/invoice/usb-token-error-modal';
import AdvModal from '@/portal-components/invoice/adv-modal';
import PublishInvoiceInfoModal from '@/portal-components/invoice/publish-invoice-info-modal';
import DetailedNotificationModal from '@/portal-components/notification/detailed-notification-modal';
import BenefitsModal from '@/portal-components/notification/benefits-modal';
import ActionsInvoiceModal from '@/portal-components/invoice/actions-invoice/actions-invoice-modal';
import InvoicePreviewModal from '@/portal-components/invoice/invoice-preview-modal';
import SendEmailModal from '@/portal-components/invoice/send-email-modal';
import ExternalInvoiceModal from '@/portal-components/invoice/external-invoice-modal';
import ErrorReportedModal from '@/portal-components/invoice/error-reported-modal';
import SaveInvoiceDraftModal from '@/portal-components/invoice/save-invoice-draft-modal'
import ChooseTaxPeriodModal from '@/portal-components/value-added-tax/choose-tax-period/choose-tax-period-modal';

import { VatReturnModal } from '@/portal-components/value-added-tax/vat-return/vat-return-modal';

export default {
  name: 'AppLayout',
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
    },
  },
  mounted() {
    document.querySelector('body').focus();
  },
  computed: {
    ...mapState([
      'appLoaded',
      'appLoading',
    ]),
  },
  components: {
    AppMobileTabs,
    ChooseTaxPeriodModal,
    VatReturnModal,
    ErrorReportedModal,
    ExternalInvoiceModal,
    InvoicePreviewModal,
    ActionsInvoiceModal,
    SendEmailModal,
    BenefitsModal,
    UsbTokenErrorModal,
    TaxAccountConnectModal,
    CreateVirtualInvoiceFormModal,
    CompanyListModal,
    InvoiceApproveListModal,
    CloneInvoiceResultModal,
    UserProfileModal,
    UserListModal,
    AppHeader,
    AppFooter,
    AppDirectoryModal,
    RuleListModal,
    CreateRuleModal,
    MoveDirectoryModal,
    InvoicePaidModal,
    InvoiceReviewModal,
    InvoiceList,
    InvoiceViewerModal,
    InvoiceUploadModal,
    InvoiceImportModal,
    InvoiceImportResultModal,
    InvoiceImportErrorModal,
    InvoiceFormModal,
    ImportInvoiceModal,
    CreateInvoiceFormModal,
    CreateDirectoryModal,
    AppDialog,
    CompanyProfileModal,
    CompanyLicenseModal,
    EInvoiceAccountListModal,
    EInvoiceAccountModal,
    TagModal,
    ViewTagInfo,
    InvoiceTagModal,
    ManageTagModal,
    AppAutocompleteSearchResult,
    ReportStatisticsModal,
    SettingModal,
    AdvModal,
    PublishInvoiceInfoModal,
    DetailedNotificationModal,
    GetTemplateModal,
    SaveInvoiceDraftModal
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/app-layout.vue